import styled from 'styled-components';

import { token } from '@zillow/constellation';

export const StyledStaticMap = styled.div`
  background-position: 50% 50%;
  background-size: cover;
  position: relative;
  background-image: ${({ backgroundImage }: { backgroundImage?: string }) => backgroundImage && backgroundImage};
`;

export const StyledOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${token('colors.black')};
  opacity: 0.3;
`;
